window.APR = window.APR || Ember.Application.create();

APR.Router.map(function () {
    this.route('search');
    this.route('attyinfo', { path: '/:reg_number/attyinfo' });
});


APR.PaginatableMixin = Ember.Mixin.create({
    paginatedContent: (function () {
        var page = this.get('page');
        var perPage = this.get('perPage');

        var totalPages = Math.ceil(this.get('model.length') / perPage);
        page = (page > totalPages) ? totalPages : page;

        var start = (page - 1) * perPage;
        var end = page * perPage;

        this.set('page', page);
        return this.get('model').slice(start, end);
    }).property('model.[]', 'page', 'perPage'),
    pages: (function () {
        var result = parseInt(this.get('model.length') / this.get('perPage'));
        if (this.get('model.length') % this.get('perPage') > 0) {
            ++result;
        }
        return result;
    }).property('model.[]', 'page', 'perPage')
});

APR.Serializable = Ember.Mixin.create({
    serialize: function () {
        var result = {};
        for (var key in $.extend(true, {}, this)) {
            // Skip these
            if (key === 'isInstance' ||
            key === 'isDestroyed' ||
            key === 'isDestroying' ||
            key === 'concatenatedProperties' ||
            key === 'uploadPromise' ||
            (this[key] !== null && this[key]._dependentKeys !== undefined && this[key]._dependentKeys !== null)||
            typeof this[key] === 'function') {
                continue;
            }
            result[key] = this[key];
        }
        return result;
    }
});

APR.SortMixin = Ember.Mixin.create({
    actions: {
        sortBy: function (sortField, model) {
            var currSort = model.getProperties('nextSort', 'sortField');
            var sortProps, sortedField;

            if (sortField == currSort.sortField) {
                sortProps = sortField + ":" + currSort.nextSort;
                sortedField = sortField + (currSort.nextSort === "asc") ? "Desc" : "Asc";
                currSort.nextSort = (currSort.nextSort === "asc") ? "desc" : "asc";
            } else {
                sortProps = sortField + ":asc";
                sortedField = sortField + "Asc";
                currSort.nextSort = "desc";
                currSort.sortField = sortField;
            }

            model.resetSortProps();
            model.set(sortedField, true);
            model.setProperties({
                recordSortProps: [sortProps],
                nextSort: currSort.nextSort,
                sortField: currSort.sortField
            });
        }
    }//,
    //setSortPropDisplay: function () {
    //    this.resetSortProps();
    //    var field = this.get('sortField');
    //    var dir = (this.get('nextSort') === "desc") ? "Asc" : "Desc";
    //    this.set(field + dir, true);
    //}.observes('sortField', 'nextSort')
});

APR.AttorneyDisciplineModel = Ember.Object.extend(APR.Serializable, {
    action: "GetAttyDiscipline",
    attyNumber: 0,

    getInfo: function () {
        var _this = this;
        return new Ember.RSVP.Promise(function (resolve, reject) {
            Ember.$.ajax({
                url: "Ajax.ashx",
                type: "POST",
                data: _this.serialize(),
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (data) { Ember.run(null, resolve, data); },
                error: function (jqhxr, status, something) { Ember.run(null, reject, arguments); }
            });
        });
    }
});

APR.AttyInfoModel = Ember.Object.extend(APR.Serializable, {
    action: "GetAttyInfo",
    attyNumber: 0,

    searchResults: null,

    getInfo: function () {
        var _this = this;
        return new Ember.RSVP.Promise(function (resolve, reject) {
            Ember.$.ajax({
                url: "Ajax.ashx",
                type: "POST",
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                data: _this.serialize(),
                success: function (data) { Ember.run(null, resolve, data); },
                error: function (jqhxr, status, something) { Ember.run(null, reject, arguments); }
            });
        });
    }
});

APR.SearchModel = Ember.Object.extend(APR.Serializable, {
    action: 'SearchAttorney',

    attyReg: '',
    emptyAR: Ember.computed.empty('attyReg'),
    badAR: Ember.computed.match('attyReg', /[a-zA-Z!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/),


    //badAR: Ember.computed.match('attyReg', /[0-9]+/),
    notValidAR: Ember.computed.or('emptyAR', 'badAR'),

    firstName: '',
    emptyFirstName: Ember.computed.empty('firstName'),

    lastName: '',
    emptyLastName: Ember.computed.empty('lastName'),

    middleName: '',
    emptyMiddleName: Ember.computed.empty('middleName'),

    address: '',
    emptyAddress: Ember.computed.empty('address'),

    city: '',
    emptyCity: Ember.computed.empty('city'),

    state: '',
    emptyState: Ember.computed.empty('state'),

    employerZip: '',
    emptyZip: Ember.computed.empty('zip'),

    county: '',
    emptyCounty: Ember.computed.empty('county'),

    isNotValidSearch: Ember.computed.and('notValidAR', 'emptyFirstName', 'emptyLastName', 'emptyMiddleName',
      'emptyAddress', 'emptyCity', 'emptyState', 'emptyCounty', 'emptyZip'),

    searchResults: null,

    isSearching: false,
    
    tooManyResults: false,

    noResults: false,

    //Sorted Search Results
    recordSortProps: ['LastName:asc','FirstName:asc'],
    recordSort: Ember.computed.sort('searchResults', 'recordSortProps'),
    nextSort: 'desc',
    sortField: 'LastName',
    AttorneyNumberAsc: true,

    resetSortProps: function () {
        this.setProperties({
            AttorneyNumberAsc: false,
            AttorneyNumberDesc: false,
            FirstNameAsc: false,
            FirstNameDesc: false,
            LastNameAsc: false,
            LastNameDesc: false,
            MiddleNameAsc: false,
            MiddleNameDesc: false
        });
    },


    search: function () {
        var _this = this;
        return new Ember.RSVP.Promise(function (resolve, reject) {
            Ember.$.ajax({
                url: "Ajax.ashx",
                type: "POST",
                data: _this.serialize(),
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (data) { Ember.
                    run(null, resolve, data); },
                error: function (jqhxr, status, something) { Ember.run(null, reject, arguments); }
            });
        });
    }
    //test: function () {
    //    let model = this;
    //    alert('hello');
    //}.observes('attyReg')
});

APR.AttorneyDisciplineRoute = Ember.Route.extend({
    model: function (params) {

        var adm = APR.AttorneyDisciplineModel.create({attorneyNumber});

        return adm.getInfo().then(function (result) {
            adm.setProperties({
                attorneyNumber: result.AttorneyNumber,
                effectiveDate: result.EffectiveDate,
                action: result.Action,
                description: result.Description,
                cmsCaseId: result.CMSCaseId,
                scCaseId: result.SCCaseNumber,
                comment1: result.Comment1,
                comment2: result.Comment2,
                comment3: result.Comment3
            });

            return adm;
        });
    }
});

APR.AttyinfoRoute = Ember.Route.extend({
    model: function (params) {

        var aim = APR.AttyInfoModel.create({ regNumber: params.reg_number });

        return aim.getInfo().then(function (result) {
            aim.setProperties({
                attorneyNumber: result.AttorneyNumber,
                formalName: result.FormalName,
                employer: result.Employer,
                address: result.Address,
                city: result.City,
                state: result.State,
                zip: result.ZipCode,
                county: result.County,
                jobTitle: result.JobTitle,
                lawSchool: result.LawSchool,
                admittedBy: result.AdmittedBy,
                admissionDate: result.AdmissionDate,
                status: result.Status,
                hasDiscipline: result.HasDiscipline,
                myDisciplines: result.MyDisciplines,
                myPreviousNames: result.MyPreviousNames,
                mySanctions: result.MySanctions,
                hasSanctions: result.HasSanctions,
                hasARDiciplines: result.hasARDisciplines,
                myARDisciplines: result.MyARDisciplines,
                businessPhoneNumber: result.BusinessPhoneNumber,
                isInvalidAddress: result.IsInvalidAddress,
                hasBusinessPhone: result.HasBusinessPhoneNumber,
                showSanctionsButton: result.ShowSactionsButton
            });

            return aim;
        });
    }
});

APR.IndexRoute = Ember.Route.extend({
    redirect: function () {
        this.transitionTo('search');
    }
});

APR.SearchRoute = Ember.Route.extend(APR.SortMixin, {
    model: function () {
        if (this.get('controller.model') === null || this.get('controller.model') === undefined) {
            return APR.SearchModel.create();
        } else {
            return this.get('controller.model');
        }
    },
    actions: {
        reset: function () {
            this.get('controller').set('model', APR.SearchModel.create());
        },
        search: function (model) {
            model.setProperties({
                isSearching: true,
                searchResults: null
            });
            model.search().then(function (resultSet) {
                model.setProperties({
                    searchResults: resultSet.MySearchResults,
                    isSearching: false,
                    tooManyResults: resultSet.TooManyResults,
                    noResults: resultSet.NoResults
                });
            });
        },
        transition: function (attyReg) {
            this.transitionTo('attyinfo', attyReg);
        }
    }
});

APR.AttySearchResultComponent = Ember.Component.extend(APR.PaginatableMixin, {
    page: 1,
    perPage: 25,
    actions: {
        sortBy: function (field) {
            this.sendAction('sortAction', field, this.get('cntlModel'));
        },
        transition: function (attyReg) {
            this.sendAction('transitionAction', attyReg);
        }
    }
});

APR.NavLinkToComponent = Ember.LinkComponent.extend({
    tagName: "li"
});

APR.PaginationLinksComponent = Ember.Component.extend({
    layoutName: 'component/pagination_links',
    hasPrevious: (function () { return this.get('page') > 1; }).property('page'),
    hasNext: (function () { return this.get('page') < this.get('pages'); }).property('page', 'pages'),
    showPagination: Ember.computed.gt('pages', 1),
    lastPage: Ember.computed.alias('pages'),
    visiblePages: (function () {
        var pages = this.get('pages');
        var page = this.get('page');
        var limit = (pages < 5) ? pages : 5;
        var finish = function (start, limit) {
            return start + limit - 1;
        };
        var start = page - parseInt(limit / 2);

        if (finish(start, limit) > pages) {
            start = pages - limit + 1;
        }
        start = (start < 1) ? 1 : start;

        return (function () {
            var results = [];
            for (var i = start, ref = finish(start, limit) ; start <= ref ? i <= ref : i >= ref; start <= ref ? i++ : i--) {
                results.push(i);
            }
            return results;
        }).apply(this);
    }).property('page', 'pages'),
    showBeforeEllipsis: (function () {
        return this.get('visiblePages.firstObject') > 1;
    }).property('visiblePages.[]'),
    showAfterEllipsis: (function () {
        return Math.abs(this.get('lastPage') - this.get('visiblePages.lastObject')) > 0;
    }).property('visiblePages.[]', 'lastPage'),

    actions: {
        goToNextPage: function () {
            if (this.get('hasNext')) {
                return this.incrementProperty('controller.page');
            }
        },
        goToPreviousPage: function () {
            if (this.get('hasPrevious')) {
                return this.decrementProperty('controller.page');
            }
        },
        goToPage: function (pageNumber) {
            if (pageNumber >= 1 && pageNumber <= this.get('lastPage')) {
                return this.set('controller.page', pageNumber);
            }
        }
    }
});

APR.PaginationPageComponent = Ember.Component.extend({
    layoutName: 'component/pagination_page',
    isCurrent: (function () {
        return this.get('currentPage') === this.get('page');
    }).property('currentPage', 'page'),
    tagName: 'li',
    classNameBindings: 'isCurrent:disabled',

    actions: {
        pageClicked: function () {
            this.get('parentView').send('goToPage', this.get('page'));
        }
    }
});
